import React from 'react'
import {Nav} from 'react-bootstrap';

const ButtonRound = (props) => {
    return (
        <Nav.Link href={props.link} onClick={props.onClick} className="roundButton">
            {props.name}
        </Nav.Link>
    )
}
export default ButtonRound;
